import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  Select,
  IconButton,
  Button,
  MenuItem,
  FormControl,
  Snackbar,
} from "@mui/material";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import "./templateCreation.scss";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { AddCircleOutline } from "@mui/icons-material";
import ProgressBar from "../../../components/ProgressBar";
import {
  clearApiStatus,
  createTemplates,
} from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";

export default function TemplateCreation() {
  const Dispatch = useDispatch();

  const initialParameters = [
    { parameter: "", sheet_name: "" },
    { parameter: "", sheet_name: "" },
    { parameter: "", sheet_name: "" },
    { parameter: "", sheet_name: "" },
    { parameter: "", sheet_name: "" },
  ];
  const [parameters, setParameters] = useState(initialParameters);
  const [noOfParameters, setNoOfParameters] = useState("");
  const [addParameter, setAddParameter] = useState([]);
  const [sheetNames, setSheetNames] = useState([]);
  const [singleSheet, setSingleSheet] = useState("");
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [outputFormat, setOutputFormat] = useState("");
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [successNotify, setSuccessNotify] = useState(false);
  // const [newJson, setNewJson] = useState({
  //   body: {
  //     template_name: { templateName },
  //     output_name: { outputFormat },
  //   },
  // });
  const [openAlert, setOpenAlert] = useState(false);
  const [open, setOpen] = useState(false);

  const [openSheetNameAlert, setOpenSheetNameAlert] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus.loader === false) {
        if (apiStatus.message !== undefined || apiStatus.message !== null) {
          if (apiStatus.next === true && apiStatus?.apiSuccess) {
            setSuccessNotify(true);
            setMessage(apiStatus.message);
            setSeverity("success");
            Dispatch(clearApiStatus());

            setSingleSheet("");
            setSheetNames([]);
            setTemplateName("");
            setOutputFormat("");
            setParameters([...initialParameters]);
            setAddParameter([]);
          } else if (apiStatus.next === false && apiStatus?.apiError) {
            setSuccessNotify(true);
            setMessage(apiStatus.message);
            setSeverity("error");
            Dispatch(clearApiStatus());
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  const addNewParameter = () => {
    setParameters([...parameters, ...addParameter]);
    setAddParameter([]);
    setNoOfParameters("");
  };

  const handleChange = (event) => {
    let counts = event.target.value;
    if (/^-?\d*$/.test(counts) && counts !== "+" && counts !== "-") {
      setNoOfParameters(counts);
      let obj = [];
      for (let index = 0; index < counts; index++) {
        obj[index] = { parameter: "", sheet_name: "" };
      }
      setAddParameter(obj);
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "+" || event.key === "-") {
      event.preventDefault();
      return;
    }

    const charCode = event.which || event.keyCode;

    // Allow only digits and backspace
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }

    // Check if the input exceeds two digits
    const inputValue = event.target.value + String.fromCharCode(charCode);
    if (inputValue.length > 2) {
      event.preventDefault();
    }
  };

  const onParameterChange = (e, index) => {
    parameters[index].parameter = e.target.value.trim();
    setParameters([...parameters]);
  };

  const onChangeSheet = (e) => {
    const inputValue = e.target.value;

    // Remove spaces only from the beginning
    const trimmedValue = inputValue.replace(/^\s+/, "");

    // Validate for special characters using a regular expression
    const isValidInput = /^[a-zA-Z0-9\s]+$/.test(trimmedValue);

    // Update the state only if the input is valid or the input is empty
    if (isValidInput || inputValue === "") {
      setSingleSheet(trimmedValue);
    }
  };

  const isSheetNameUnique = (newSheetName, existingSheetNames) => {
    // Convert existing sheet names to lowercase for case-insensitive comparison
    const lowerCaseExistingSheetNames = existingSheetNames.map((name) =>
      name.toLowerCase()
    );

    // Convert new sheet name to lowercase for case-insensitive comparison
    const lowerCaseNewSheetName = newSheetName.toLowerCase();

    // Check if the lowercased new sheet name already exists in the array
    return !lowerCaseExistingSheetNames.includes(lowerCaseNewSheetName);
  };

  const addSheetNames = () => {
    const trimmedValue = singleSheet.trim();
    // Check if singleSheet is not empty and not already present in sheetNames
    if (isSheetNameUnique(trimmedValue, sheetNames)) {
      setSheetNames([...sheetNames, trimmedValue]);
      setSingleSheet("");
      setOpen(true);
    } else {
      setOpenSheetNameAlert(true);
      // Handle the case where singleSheet is empty or already present
      // You can show a message, set an error state, etc.
    }
  };
  const addTemplateName = (e) => {
    setTemplateName(e.target.value.trim());
  };
  const addOutputName = (e) => {
    setOutputFormat(e.target.value.trim());
  };
  const deleteParameters = (index) => {
    // Make a copy of the array to avoid mutating the original array
    const updatedParameters = [...parameters];

    // Remove the element at the specified index
    updatedParameters.splice(index, 1);

    // Update the state or perform any other necessary actions
    setParameters([...updatedParameters]);
  };
  const onSelectedSheet = (e, index) => {
    parameters[index].sheet_name = e.target.value;
    setParameters([...parameters]);
  };

  const clickToSave = () => {
    const isValid = parameters.every(
      (param) => param.parameter !== "" && param.sheet_name !== ""
    );

    if (!isValid) {
      setOpenAlert(true);
    } else {
      // If validation passes, proceed with the rest of your logic
      finalJson(parameters);
    }
  };
  const finalJson = () => {
    const generatedJson = {
      body: {
        template_name: templateName,
        output_name: outputFormat,
      },
    };

    parameters.forEach((item) => {
      const { sheet_name, parameter } = item;

      if (!generatedJson.body[sheet_name]) {
        generatedJson.body[sheet_name] = [];
      }

      generatedJson.body[sheet_name].push(parameter);
    });

    // setNewJson(generatedJson);
    Dispatch(createTemplates(generatedJson));
  };

  return (
    <Box>
      <Header />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader text="Template Creation" />
            <Grid container className="upper-container">
              <Grid item xs={5} className="form-style-wrap">
                <FormControl className="form-style">
                  <TextField
                    className="upper-container-input"
                    size="small"
                    placeholder="Sheet Name"
                    value={singleSheet}
                    onChange={(e) => onChangeSheet(e)}
                  />
                  <Button
                    className="save-btn"
                    onClick={addSheetNames}
                    disabled={singleSheet === ""}
                  >
                    +Add
                  </Button>
                </FormControl>
              </Grid>

              <Grid item xs={7}>
                <TextField
                  className="upper-container-input"
                  size="small"
                  placeholder="Template Name"
                  value={templateName}
                  onChange={(e) => addTemplateName(e)}
                />
                <TextField
                  className="upper-container-input"
                  size="small"
                  placeholder="Output Format Name"
                  value={outputFormat}
                  onChange={(e) => addOutputName(e)}
                />
                <Button
                  disabled={
                    templateName === "" ||
                    outputFormat === "" ||
                    parameters.length === 0
                      ? true
                      : false
                  }
                  className="save-btn"
                  onClick={clickToSave}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
            <Box className="mid-container">
              {parameters?.map((param, index) => (
                <Box className="mid-box">
                  <TextField
                    className="input-text"
                    placeholder="Parameter Name"
                    size="small"
                    value={param?.parameter}
                    onChange={(e) => onParameterChange(e, index)}
                  />

                  <Select
                    displayEmpty
                    className="input-select"
                    id={index}
                    inputProps={{ "aria-label": "Without label" }}
                    size="small"
                    value={param?.sheet_name}
                    onChange={(e) => onSelectedSheet(e, index)}
                  >
                    <MenuItem disabled value="">
                      <em>Select Sheet</em>
                    </MenuItem>
                    {sheetNames?.map((index) => (
                      <MenuItem value={index}>{index}</MenuItem>
                    ))}
                  </Select>
                  {/* </FormControl> */}
                  {/* </div> */}
                  <IconButton
                    onClick={() => deleteParameters(index)}
                    size="small"
                    className="delete-forever"
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                  {/* </FormControl> */}
                </Box>
              ))}
            </Box>
            <Grid className="lower-container" container>
              <Grid item xs={6} className="lower-container-item">
                <TextField
                  className="input-text"
                  placeholder="No of Parameters"
                  size="small"
                  value={noOfParameters}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                  type="text"
                />
                <IconButton
                  onClick={addNewParameter}
                  disabled={noOfParameters === ""}
                >
                  <AddCircleOutline />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {apiStatus?.loader && <ProgressBar />}

      {/* {loader && <ProgressBar></ProgressBar>} */}
      {successNotify && (
        <CustomizedSnackbars
          severity={severity}
          state={successNotify}
          text={message}
          handleClose={() => setSuccessNotify(false)}
        />
      )}

      {openAlert && (
        <CustomizedSnackbars
          severity={"error"}
          state={openAlert}
          text={
            "Please provide values for both parameter and sheet name for all entries."
          }
          handleClose={() => setOpenAlert(false)}
        />
      )}

      {openSheetNameAlert && (
        <CustomizedSnackbars
          severity={"error"}
          state={openSheetNameAlert}
          text={"Sheet name alread exist."}
          handleClose={() => setOpenSheetNameAlert(false)}
        />
      )}

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={handleClose}
        message="Sheet Name Added Successfully"
        key={"topcenter"}
        autoHideDuration={2000}
      />
    </Box>
  );
}
